import PropTypes from 'prop-types';
// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import ProjectStepperForm from '../project-stepper-form';

// ----------------------------------------------------------------------

export default function ProjectView({ projectData }) {
  return (
    <Container sx={{ my: 0, flex: 1 }}>
      <Stack spacing={7} sx={{ flexDirection: { xs: 'column', md: 'row' } }} height="100%">
        <ProjectStepperForm projectData={projectData} />
      </Stack>
    </Container>
  );
}

ProjectView.propTypes = {
  projectData: PropTypes.object,
};